import React from 'react';
import { useTranslation } from 'react-i18next';
import { IVehicle } from './types';
import VehiclePriceEstimateLogic from 'components/Vehicles/VehiclePriceEstimate/VehiclePriceEstimateLogic';
import ErrorComponent from 'components/Errors/ErrorComponent';
import LoadingIndicator from 'components/LoadingIndicator';
import Button from 'components/UI/Button';

import './vehicle-price-estimate-display-new.pcss';

export function AddPriceEstimateEvent ({
    vehicle,
    onSuccess,
}: {
    vehicle: IVehicle,
    onSuccess?: () => void,
}) {
    const { t } = useTranslation('vehicles');

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const handleSubmitPricePredictionEvent = async (createVehiclePricePredictionEvent) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
        await createVehiclePricePredictionEvent(vehicle.id).then(() => {
            onSuccess?.();
        });
    };

    return (
        <VehiclePriceEstimateLogic>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {({ loading, error, createVehiclePricePredictionEvent }: { loading: boolean, error: boolean, // @ts-ignore
                createVehiclePricePredictionEvent }) => {
                if (error) return <ErrorComponent error={error} />;
                if (loading) return <LoadingIndicator size="s" />;

                return (
                    <Button
                        trackName="addPriceEstimateToTimeline"
                        onClick={() => handleSubmitPricePredictionEvent(createVehiclePricePredictionEvent)}
                        className="add-price-estimate-button button button--tertiary button--medium"
                        type="button"
                        loading={loading}
                    >
                        {t('vehicles:pricePrediction.addPriceEstimateToTimeline.add')}
                    </Button>
                );
            }}
        </VehiclePriceEstimateLogic>
    );
}
